export const authConfig = {
  usernameAuth: process.env.REACT_APP_VEZETI_USER,
  passwordAuth: process.env.REACT_APP_VEZETI_PASSWORD
};

export const url = 'https://secure.vezeti.net/test-api/v3/';
